import "./zodConfig";
import "@sidegigllc/api/resources/form-errors";
// setConfig() for the generated client — must run before route loaders (eager, not via the lazy Root chunk)
import "api/interceptors";
import "./instrument";
import * as Sentry from "@sentry/react";
import React from "react";
import { createRoot } from "react-dom/client";
import { env } from "./config/env";
import { Router } from "./routing/router";

if (!env.IS_PROD) {
  const meta = document.createElement("meta");
  meta.name = "robots";
  meta.content = "noindex, nofollow";
  document.head.appendChild(meta);
}

const root = createRoot(document.getElementById("root")!, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler(),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
});

const App = Sentry.withProfiler(Router);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
